import '.bn{flex-shrink:0;}.ssr-plugin'
import '.bo{padding:1rem;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.bf{height:100%;}.ssr-plugin'
import '.b8{border:none;}.ssr-plugin'
import '.fn{background-color:transparent;}.ssr-plugin'
import '.fo{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ac{align-items:stretch;}.ssr-plugin'
import '.c9{position:sticky;}.ssr-plugin'
import '.fp{top:4rem;}.ssr-plugin'
import '.fq{z-index:7;}.ssr-plugin'
import '.af{background-color:var(--palette-white);}.ssr-plugin'
import '.fr{padding-bottom:1rem;}.ssr-plugin'
import '.n{margin-bottom:1rem;}.ssr-plugin'
import '.fs{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.x{position:fixed;}.ssr-plugin'
import '.ca{top:0px;}.ssr-plugin'
import '.bk{left:0px;}.ssr-plugin'
import '.bl{right:0px;}.ssr-plugin'
import '.ft{bottom:0px;}.ssr-plugin'
import '.fu{z-index:9999;}.ssr-plugin'
import '.fv{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.d4{justify-content:flex-end;}.ssr-plugin'
import '.bj{flex:1;}.ssr-plugin'
import '.al{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bn bo a0 bf b8 fn fo"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ac"
    >
      <div className="c9 fp fq af fr n fs a"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="x ca bk bl ft fu af fv a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bo a d4 fs"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bj al">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
